import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import DropdownMenu from "@/components/DropdownMenu";
import TargetLink from "@/components/TargetLink";
import { useAdultModeQuery, useInformationsLazyQuery } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import Link from "next/link";
import { memo, useCallback, useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconBell = function IconBell(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-1)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M10.2,3.3a1.884,1.884,0,0,1-.2-.8,2,2,0,0,1,4,0,2.354,2.354,0,0,1-.2.8",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        strokeWidth: "1.32"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12,19.5H1.5v-2h0a7.3,7.3,0,0,0,4.3-6.655V9.2A6.2,6.2,0,0,1,12,3h0a6.2,6.2,0,0,1,6.2,6.2v1.645A7.3,7.3,0,0,0,22.5,17.5h0v2Z",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        strokeWidth: "1.32"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.5,19.5V20a3.5,3.5,0,1,1-7,0v-.5",
        fill: "none",
        stroke: "#000",
        strokeMiterlimit: "10",
        strokeWidth: "1.32"
      })]
    })
  }));
};

IconBell.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  viewBox: "0 0 22 24"
};

function Notice() {
  var _data$informations, _data$informations2, _data$informations2$p;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      _useAdultModeQuery$da = _useAdultModeQuery.data;

  _useAdultModeQuery$da = _useAdultModeQuery$da === void 0 ? {} : _useAdultModeQuery$da;
  var adultMode = _useAdultModeQuery$da.adultMode;

  var _useInformationsLazyQ = useInformationsLazyQuery(),
      _useInformationsLazyQ2 = _slicedToArray(_useInformationsLazyQ, 2),
      getInformations = _useInformationsLazyQ2[0],
      data = _useInformationsLazyQ2[1].data;

  var _useState = useState(false),
      badge = _useState[0],
      setBadge = _useState[1];

  var informations = data === null || data === void 0 ? void 0 : (_data$informations = data.informations) === null || _data$informations === void 0 ? void 0 : _data$informations.data;
  var totalCount = (data === null || data === void 0 ? void 0 : (_data$informations2 = data.informations) === null || _data$informations2 === void 0 ? void 0 : (_data$informations2$p = _data$informations2.pageInfo) === null || _data$informations2$p === void 0 ? void 0 : _data$informations2$p.totalCount) || 0;
  var handleListClick = useCallback(function () {
    var latest = informations[0];

    if (latest) {
      window.localStorage.setItem("currentInformarion", latest.id);
      setBadge(false);
    }
  }, [informations]);
  useEffect(function () {
    var adultOrVod = adultMode ? "adult" : "vod";
    var key = config.information[adultOrVod];
    getInformations({
      variables: {
        key: key,
        offset: 0,
        limit: 10
      }
    });
  }, [adultMode]);
  useEffect(function () {
    if (informations) {
      var latest = informations[0];

      if (latest) {
        window.localStorage.setItem("latestInformation", latest.id);
        var current = window.localStorage.getItem("currentInformarion");

        if (latest.id != current) {
          setBadge(true);
        }
      }
    }
  }, [informations]);
  return /*#__PURE__*/_jsx("div", {
    className: styles.notice,
    children: /*#__PURE__*/_jsx(DropdownMenu, {
      right: true,
      button: /*#__PURE__*/_jsx("a", {
        className: styles.noticeBtn,
        children: /*#__PURE__*/_jsx("div", {
          className: classnames(styles.noticeIcon, _defineProperty({}, styles.hasNotice, badge)),
          children: /*#__PURE__*/_jsx(IconBell, {})
        })
      }),
      scopedClass: dropDownStyles.forHeaderMenu,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.noticeList,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.inner,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.list,
            children: informations && /*#__PURE__*/_jsx("ul", {
              children: informations.map(function (info) {
                return /*#__PURE__*/_jsxs("li", {
                  children: [/*#__PURE__*/_jsx("span", {
                    className: styles.noticeDate,
                    children: info.date && info.date
                  }), /*#__PURE__*/_jsx(TargetLink, {
                    href: info.url,
                    blank: info.targetBlank,
                    children: info.title
                  })]
                }, "notice-".concat(info.id));
              })
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.index,
            children: [totalCount > 0 && /*#__PURE__*/_jsx(Link, {
              href: routes.informations,
              children: /*#__PURE__*/_jsx("a", {
                onClick: handleListClick,
                children: "\u304A\u77E5\u3089\u305B\u4E00\u89A7\u3078"
              })
            }), totalCount == 0 && /*#__PURE__*/_jsx("span", {
              children: "\u304A\u77E5\u3089\u305B\u306F\u3042\u308A\u307E\u305B\u3093"
            })]
          })]
        })
      })
    })
  });
}

export default /*#__PURE__*/memo(Notice);